import React, { useEffect, useState} from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { decryptToken } from '../../utils/Crypto';
import { checkAuth } from '../../api/axios';

const ProtectedRoute = ({ children }) => {
    const [loading, setLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    
    useEffect(() => {
      const checkToken = async () => {
        try {
          const token = localStorage.getItem('accessToken');
          if (token) {
            await checkAuth('accessToken');
            setIsAuthenticated(true);
          } else {
            setIsAuthenticated(false);
          }
        } catch (error) {
          setIsAuthenticated(false);
        } finally {
          setLoading(false);
        }
      };
  
      checkToken();
    }, []);
  
    if (loading) {
      return <div>Loading...</div>;
    }
  
    if (!isAuthenticated) {
      return <Navigate to="/login" />;
    }
  
    return children;
  };
  
  export default ProtectedRoute;